export enum TransferStateKeyEnum {
  APP_CONFIG = 'APP_CONFIG',
  WINDOW_SIZE = 'WINDOW_SIZE',
  DEVICE_TYPE = 'DEVICE_TYPE',
  GUIDE_RESPONSE_DATA = 'GUIDE_RESPONSE_DATA',
  BLOG_RESPONSE_DATA = 'BLOG_RESPONSE_DATA',
  NATIVE_RESPONSE_DATA = 'NATIVE_RESPONSE_DATA',
}
